import React from 'react';

import { FormikDatePicker, FormikSelect } from 'components/UiKit/FormikFields';
import FormField from 'screens/Equipment/components/FormField';
import { statuses } from '../../helpers/constants';

const CurrentStatusField = () => {
  return (
    <div className="flex">
      <div data-testid="equipment-item-current-status" className="w-1/2 mr-8">
        <FormField label="Current Status *" htmlFor="currentStatus">
          <FormikSelect
            id="currentStatus"
            name="currentStatus"
            items={statuses}
            placeholder="Select"
          />
        </FormField>
      </div>
      <div className="w-1/2">
        <FormField label="Current Status Date" htmlFor="currentStatusDate">
          <FormikDatePicker
            id="currentStatusDate"
            name="currentStatusDate"
            format="MMM DD, YYYY"
          />
        </FormField>
      </div>
    </div>
  );
};

export default CurrentStatusField;
